var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"container",style:(`width: calc(${_vm.width || '100'}% - ${_vm.sideBarWidth}px) !important; left: ${Math.floor(_vm.sideBarWidth/2)}px;`)},[_c('div',{staticClass:"card tcs-card elevate-2 borderless tcs-top container py-3"},[_c('div',{staticClass:"tcs-card-header"},[_vm._t("header")],2),_vm._t("one")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }